import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import styled from 'styled-components';

const SyledCopyrightsBox = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 15px;
`;

const StyledParagraph = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.color.first};
  font-family: 'Open Sans', sans-serif;
  font-size: ${({ theme }) => theme.font.size.xxxs};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  ${({ theme }) => theme.mq.tablet} {
    font-size: ${({ theme }) => theme.font.size.xxs};
  }
`;

const SyledLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.color.second};
  font-family: 'Open Sans', sans-serif;
  font-size: ${({ theme }) => theme.font.size.xxs};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  margin: 0 5px;
  &:hover,
  &:active {
    color: ${({ theme }) => theme.color.fourth};
  }
`;

const CopyrightParagraph = () => {
  let paragraph = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.from(paragraph, 1, {
      opacity: 0,
      rotationX: -150,
      scrollTrigger: paragraph,
    });
  }, []);
  return (
    <SyledCopyrightsBox>
      <StyledParagraph
        ref={el => {
          paragraph = el;
        }}
      >
        Mr Locum Sp. z o.o.© {new Date().getFullYear()},&nbsp;
        <span>Projekt i wykonanie </span>
        <SyledLink
          aria-label="strona autor"
          href="https://github.com/domaradzki"
        >
          Domaradzki.dev
        </SyledLink>
      </StyledParagraph>
    </SyledCopyrightsBox>
  );
};

export default CopyrightParagraph;
